import React from 'react'
import { ClientSecureWrapper } from 'src/components/layout/client/ClientSecureWrapper'
import { CollectDataForm } from 'src/components/collect-data-form/CollectDataForm'

export const FormPage = () => {
  return (
    <ClientSecureWrapper>
      <CollectDataForm />
    </ClientSecureWrapper>
  )
}
